import React from "react";
import { NavLink } from "react-router-dom";
import { Nav } from "reactstrap";
import MenuItems from "./items.data";

import "./nav-panel.component.scss";

// Distancia desde la parte superior en una vista normal, sin considerar el la altura del header.
const FIXED_FROM = 71;
// Ancho minimo de pantalla en que se puede mostrar el menú dentro del cuerpo de la pagína
const VISIBLE_IN_BODY_FROM = 1200;

class PanelDeNavegacion extends React.Component {
  constructor(props) {
    super(props);
    let me = this;
    me.activeRoute = me.activeRoute.bind(me);
    me.state = {
      // modes: fixed|dicked|hidden
      mode: me.getInitialMode()
    };
    me.rootNode = React.createRef();
    // Scroll Listener
    window.addEventListener("scroll", me.scrollHandler.bind(me));
    // Scroll Listener
    window.addEventListener("resize", me.resizeHandler.bind(me));
  }
  activeRoute(routeName) {
    // eslint-disable-next-line react/prop-types
    return this.props.location.pathname.indexOf(routeName) > -1 ? "active" : "";
  }
  render() {
    let me = this;
    const { mode } = me.state;
    return (
      <div className={`nav-panel nav-panel--${mode}`} ref={me.rootNode}>
        <div className="nav-panel__backdrop" onClick={me.hide.bind(me)} />
        <div className="nav-panel-content-wrapper">
          <div className="nav-panel__header" />
          <Nav>
            {MenuItems.map((prop, key) => {
              return (
                <li className={me.activeRoute(prop.path)} key={key}>
                  <NavLink
                    to={prop.path}
                    className="nav-link"
                    activeClassName="active"
                    onClick={me.onItemClick.bind(me)}
                  >
                    <i className={prop.icon} />
                    <span>{prop.text}</span>
                  </NavLink>
                </li>
              );
            })}
          </Nav>
          <div className="nav-panel__footer" />
        </div>
      </div>
    );
  }
  resizeHandler() {
    let me = this,
      currentMode = me.state.mode,
      isHidden = currentMode === "hidden";
    // Ocuto: no aplica
    if (isHidden && me.hiddenByUser) {
      return;
    }
    if (!me.canBeShownInPageBody()) {
      me.changeMode("hidden");
      return;
    }
    if (isHidden && !me.hiddenByUser) {
      if (me.shouldBeFixed()) {
        me.changeMode("fixed");
      } else {
        me.changeMode("docked");
      }
    }
  }
  scrollHandler() {}
  /**
   * Monitorea el scroll para determinar si el menú debería cambiar a modo estatico
   * mode: 'fixed' aplica cuando
   * 1) el componente no está oculto
   * 2) El componente puede ser mostrado en el body
   * mode: 'fixed'
   */
  scrollHandler_old() {
    let me = this,
      currentMode = me.state.mode,
      isFixed = currentMode === "fixed",
      isHidden = currentMode === "hidden",
      needsToBeFixed = me.shouldBeFixed();
    // Ocuto: no aplica
    if (isHidden) {
      return;
    }
    // El coponente no puede ser mostrado en el body
    if (!me.canBeShownInPageBody()) {
      return;
    }
    // Necesita estar en modo fixed y ya está en modo fixed
    if (needsToBeFixed && isFixed) {
      return;
    }
    // No necesita estar en modo fixed y tampoco está en modo fixed
    if (!needsToBeFixed && !isFixed) {
      return;
    }
    /**
     * 1. El componente no está oculto
     * 2. Puede ser mostrádo en el cuerpo de la página.
     *
     * Es fixed y no necesita estár en modo fixed
     */
    if (isFixed && !needsToBeFixed) {
      me.changeMode("docked");
    }
    // No es fixed y necesita estar fijo
    if (!isFixed && needsToBeFixed) {
      me.changeMode("fixed");
    }
  }
  show() {
    this.setState({ shown: true });
  }
  hide() {
    this.changeMode("hidden");
  }
  /**
   * Ocoulta el menú se se enuentra en modo mobile
   */
  onItemClick() {
    if (this.isOver()) {
      this.changeMode("hidden");
    }
  }
  /**
   * Togle mostrar ú ocular menú.
   */
  toggle() {
    let me = this;
    me.hiddenByUser = false;
    // Visible
    if (!me.isHidden()) {
      me.hiddenByUser = true;
      me.changeMode("hidden");
      return;
    }
    // No visible
    // Puede ser mostrádo en el cuerpo de la pagina
    if (me.canBeShownInPageBody()) {
      if (me.shouldBeFixed()) {
        me.changeMode("docked");
      } else {
        me.changeMode("docked");
      }
      return;
    }
    // No puede ser mostrado en el cuerpo de la pagina
    me.changeMode("over");
  }
  isHidden() {
    return this.state.mode === "hidden";
  }
  isFixed() {
    return this.state.mode === "fixed";
  }
  isDocked() {
    return this.state.mode === "docked";
  }
  isOver() {
    return this.state.mode === "over";
  }
  /**
   * Indica si el menu puede ser mostrádo como parte del cuerpo de la pagina
   */
  canBeShownInPageBody() {
    return document.body.offsetWidth >= VISIBLE_IN_BODY_FROM;
  }
  /**
   * Indica si el menú deberia pasar a modo estatico
   */
  shouldBeFixed() {
    return (
      document.documentElement.scrollTop > FIXED_FROM ||
      document.body.scrollTop > FIXED_FROM
    );
  }
  getInitialMode() {
    let me = this;
    //Oculto
    if (!me.canBeShownInPageBody()) {
      return "hidden";
    }
    if (me.shouldBeFixed()) {
      return "fixed";
    }
    return "docked";
  }
  getMode() {
    return this.state.mode;
  }
  changeMode(mode) {
    let me = this;
    me.setState({ mode }, function() {
      me.props.mainPage.setSidenavMode(mode);
    });
  }
}
export default PanelDeNavegacion;
export { FIXED_FROM };
